export default __webpack_public_path__ + "static/media/select.88bdc26d.svg";